import * as Constants from '../Constants';
import moment from 'moment-timezone';

export const getTZDate = (date, sitetz) => {
  return moment.tz(date, sitetz);
};

export const getTZDateAsString = (date, sitetz) => {
  return moment.tz(date, sitetz).format(Constants.DATE_FORMAT);
};

export const getTZDateTimeAsString = (date, sitetz) => {
  return moment.tz(date, sitetz).format(Constants.DATE_TIME_FORMAT);
};
